'use client'

import ImageComponent from "@/components/ui/ImageComponent";
import RatingStar from "@/components/ui/RatingStar";
import LineReadMore from "@/components/ui/ReadMore/LineReadMoreIndex";
import ReadMore from "@/components/ui/ReadMore/ReadMoreIndex";
import { replaceTemplatePlaceholders } from "@/util/replaceTemplateText";

interface HairRemovalReviewProps {
    title: string;
    subtitle: string;
    rating: number;
    proceduresDone: number;
    description: string;
    cityName: string | null;
}

const HairRemovalReviewIndex = ({
    title,
    subtitle,
    rating,
    proceduresDone,
    description,
    cityName
}: HairRemovalReviewProps) => {

    const titleText = replaceTemplatePlaceholders(title,title,cityName||'');
    const subtitleText = replaceTemplatePlaceholders(subtitle, title, cityName || '');
    const descriptionText = replaceTemplatePlaceholders(description, title, cityName || '');

    return (
        <div className="space_from_side">
            <div className="flex justify-between gap-y-3 items-center flex-wrap md:flex-nowrap">
                <div className="space-y-4 flex-1">
                    <div className="space-y-1">
                        <h1 className="h1_heading_text font-bold! md:font-semibold! text-center lg:text-start">{titleText}</h1>
                        <p className="text-textf2 text-base/[25.6px] font-normal text-center lg:text-start w-full md:w-11/12">
                            {subtitleText}
                        </p>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="w-1/2">
                            <div className="mx-auto flex gap-1 items-center justify-start">
                                <div className="h-auto md:h-10 w-4.5 md:w-[33px]">
                                    <ImageComponent url="/images/home_data/google_logo.svg" />
                                </div>

                                <div className="text-[#040404] text-lg md:text-[24px]/[33.6px] font-semibold ml-2">
                                    {rating}
                                </div>

                                <div className="flex flex-col">
                                    <RatingStar starColor="#FFC107" height="23px" width="21px" totalRating={rating} />
                                </div>
                            </div>
                            <span className="text-textf1 text-xs md:text-base/[25.6px] font-normal pl-3">
                                Google ratings
                            </span>
                        </div>

                        <div className="border-l-1 border-[#C4C2C2] pl-[11px] flex-1">
                            <div className="font-semibold text-2xl/[33.6px] text-textf1">{proceduresDone}</div>
                            <div className="text-base/[25.6px] text-textf1 font-normal">Sessions Done</div>
                        </div>
                    </div>
                </div>

                <div className="font-normal text-base/[29px] text-textf1 w-full md:w-[55%] xl:w-[60%]">
                    <ReadMore text={descriptionText} showlength={{
                        default: 15, 
                        sm: 15,       
                        md: 25,       
                        lg: 30,
                        xl: 40,      
                    }} />
                    {/* <LineReadMore text={descriptionText}/> */}
                </div>
            </div>
        </div>
    );
};

export default HairRemovalReviewIndex;
